// extracted by css-extract-rspack-plugin
export default {"body":"GdeB0BO8trMoFeR6"};